import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// layouts
import { AdminComponent } from "./layouts/admin/admin.component";
import { AuthComponent } from "./layouts/auth/auth.component";

// admin views
import { DashboardComponent } from "./views/admin/dashboard/dashboard.component";
import { MapsComponent } from "./views/admin/maps/maps.component";
import { SettingsComponent } from "./views/admin/settings/settings.component";
import { TablesComponent } from "./views/admin/tables/tables.component";

// auth views
import { LoginComponent } from "./views/auth/login/login.component";
import { RegisterComponent } from "./views/auth/register/register.component";

// no layouts views
import { IndexComponent } from "./views/index/index.component";
import { LandingComponent } from "./views/landing/landing.component";
import { ProfileComponent } from "./views/profile/profile.component";

// components for views and layouts

import { MatMenuModule } from "@angular/material/menu";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CardBarChartComponent } from "./components/cards/card-bar-chart/card-bar-chart.component";
import { CardLineChartComponent } from "./components/cards/card-line-chart/card-line-chart.component";
import { CardPageVisitsComponent } from "./components/cards/card-page-visits/card-page-visits.component";
import { CardProfileComponent } from "./components/cards/card-profile/card-profile.component";
import { CardSettingsComponent } from "./components/cards/card-settings/card-settings.component";
import { CardSocialTrafficComponent } from "./components/cards/card-social-traffic/card-social-traffic.component";
import { CardStatsComponent } from "./components/cards/card-stats/card-stats.component";
import { CardTableComponent } from "./components/cards/card-table/card-table.component";
import { IndexDropdownComponent } from "./components/dropdowns/index-dropdown/index-dropdown.component";
import { NotificationDropdownComponent } from "./components/dropdowns/notification-dropdown/notification-dropdown.component";
import { PagesDropdownComponent } from "./components/dropdowns/pages-dropdown/pages-dropdown.component";
import { TableDropdownComponent } from "./components/dropdowns/table-dropdown/table-dropdown.component";
import { UserDropdownComponent } from "./components/dropdowns/user-dropdown/user-dropdown.component";
import { FooterAdminComponent } from "./components/footers/footer-admin/footer-admin.component";
import { FooterSmallComponent } from "./components/footers/footer-small/footer-small.component";
import { FooterComponent } from "./components/footers/footer/footer.component";
import { HeaderStatsComponent } from "./components/headers/header-stats/header-stats.component";
import { MapExampleComponent } from "./components/maps/map-example/map-example.component";
import { AdminNavbarComponent } from "./components/navbars/admin-navbar/admin-navbar.component";
import { AuthNavbarComponent } from "./components/navbars/auth-navbar/auth-navbar.component";
import { IndexNavbarComponent } from "./components/navbars/index-navbar/index-navbar.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { DefaultComponent } from "./layouts/default/default.component";
import { EmpresasComponent } from "./views/catalogs/empresas/empresas.component";

import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { EmpresaForm } from "./views/catalogs/empresas/form/form.component";
import { FuncionamientoForm } from "./views/catalogs/funcionamiento/form/form.component";
import { FuncionamientoComponent } from "./views/catalogs/funcionamiento/funcionamiento.component";
import { ProveedorForm } from "./views/catalogs/proveedores/form/form.component";
import { ProveedoresComponent } from "./views/catalogs/proveedores/proveedores.component";
import { TipoMaterialForm } from "./views/catalogs/tipos-materiales/form/form.component";
import { TiposMaterialesComponent } from "./views/catalogs/tipos-materiales/tipos-materiales.component";
import { TiposUnidadForm } from "./views/catalogs/tipos-unidades/form/form.component";
import { TiposUnidadesComponent } from "./views/catalogs/tipos-unidades/tipos-unidades.component";

import { OperadorForm } from "./views/workers/operadores/form/form.component";
import { OperadoresComponent } from "./views/workers/operadores/operadores.component";

import { NgxGaugeModule } from "ngx-gauge";
import { NgxImageCompressService } from "ngx-image-compress";
import { InventarioComponent } from "./views/materials/inventario/inventario.component";
import { MaterialForm } from "./views/materials/materials/form/form.component";
import { MaterialsComponent } from "./views/materials/materials/materials.component";
import { MovementsComponent } from "./views/materials/movements/movements.component";
import { RecepcionForm } from "./views/recepcion/recepcion/form/form.component";
import { RecepcionComponent } from "./views/recepcion/recepcion/recepcion.component";
import { UnidadForm } from "./views/recepcion/unidades/form/form.component";
import { UnidadesComponent } from "./views/recepcion/unidades/unidades.component";

import { AngularSignaturePadModule } from "@almothafar/angular-signature-pad";
import { CommonModule } from "@angular/common";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { NgxSpinnerModule } from "ngx-spinner";
import { CardFilterComponent } from "./components/cards/card-filter/card-filter.component";
import { SearchCardUnitsComponent } from "./components/shared/search-units/card-units/card-units.component";
import { SearchUnitModal } from "./components/shared/search-units/modal/modal.component";
import { SearchUnitsComponent } from "./components/shared/search-units/search-units.component";
import { AuthGuard } from "./guards/auth-guard.guard";
import { InventarioLayout } from "./layouts/inventario/inventario.component";
import { JwtInterceptor } from "./utils/jwt.interceptor";
import { DateGmt8Pipe } from "./utils/date-gmt8.pipe";
import { AlertasComponent } from "./views/admin/alertas/alertas.component";
import { AlertasForm } from "./views/admin/alertas/form/form.component";
import { AlertaProgramadasModal } from "./views/admin/alertas/modal-programadas/modal.component";
import { ResumenComponent } from "./views/admin/dashboard/resumen/resumen.component";
import { ResumenStatsComponent } from "./views/admin/dashboard/resumen/stats/stats.component";
import { ReportsComponent } from "./views/admin/reportes/reportes.component";
import { UsersForm } from "./views/admin/users/form/form.component";
import { UsersComponent } from "./views/admin/users/users.component";
import { PlantasForm } from "./views/catalogs/plantas/form/form.component";
import { PlantasComponent } from "./views/catalogs/plantas/plantas.component";
import { InventarioFilteromponent } from "./views/materials/inventario/filter/filter.component";
import { MovimientosModal } from "./views/materials/modal/modal.component";
import { ActasAdminComponent } from "./views/otros/actas/actas.component";
import { ActasAdminForm } from "./views/otros/actas/form/form.component";
import { CajaComponent } from "./views/otros/caja/caja.component";
import { CajaFormComponent } from "./views/otros/caja/form/form.component";
import { CajaModalComponent } from "./views/otros/caja/modal/modal.component";
import { CartasComponent } from "./views/otros/cartas/cartas.component";
import { CartasCompromisoForm } from "./views/otros/cartas/form/form.component";
import { AsignacionComponent } from "./views/recepcion/asignacion/asignacion.component";
import { HistorialAsignarModal } from "./views/recepcion/asignacion/historial/historial.component";
import { AsignarModal } from "./views/recepcion/asignacion/modal/modal.component";
import { EntregaComponent } from "./views/recepcion/entrega/entrega.component";
import { EntregaForm } from "./views/recepcion/entrega/form/form.component";
import { PolizaForm } from "./views/recepcion/polizas/form/form.component";
import { PolizaModal } from "./views/recepcion/polizas/modal-poliza/modal-poliza.component";
import { PolizasComponent } from "./views/recepcion/polizas/polizas.component";
import { HistorialMantenimientoComponent } from "./views/taller/historial/historial.component";
import { MantenimientoForm } from "./views/taller/mantenimiento/form/form.component";
import { MantenimientoComponent } from "./views/taller/mantenimiento/mantenimiento.component";
import { MantenimientoDetalleModal } from "./views/taller/mantenimiento/modal-detail/modal.component";
import { MantenimientoIniciarModal } from "./views/taller/mantenimiento/modal-iniciar/modal.component";
import { MantenimientoMaterialModal } from "./views/taller/mantenimiento/modal-material/modal.component";
import { MantenimientoTerminarModal } from "./views/taller/mantenimiento/modal-terminar/modal.component";
import { MantProgramarHistorialModal } from "./views/taller/programar/historial/modal.component";
import { ProgramarModal } from "./views/taller/programar/modal/modal.component";
import { ProgramarComponent } from "./views/taller/programar/programar.component";
import { BlackListComponent } from "./views/workers/blacklist/blacklist.component";
import { BlackListForm } from "./views/workers/blacklist/form/form.component";
import { BajaOperadorFormModal } from "./views/workers/operadores/baja/baja.component";

import { MatCheckboxModule } from "@angular/material/checkbox";
import { AlmacenEstantesComponent } from "./almacen-estantes/almacen-estantes.component";
import { AvatarComponent } from "./components/dropdowns/avatar/avatar.component";
import { ForbiddenComponent } from "./pages/forbidden/forbidden.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { HistorialUnidadComponent } from "./views/recepcion/historial/historial.component";
import { HistorialUnidadTableComponent } from "./views/recepcion/historial/special-table/special-table.component";
import { RevisionPercancesForm } from "./views/recepcion/revision/form/form.component";
import { RevisionPercancesComponent } from "./views/recepcion/revision/revision.component";
import { MantenimientoResumenModal } from "./views/taller/mantenimiento/modal-resumen/modal.component";
import { IdCardsComponent } from "./views/workers/idcards/idcards.component";
import { HistorialAsignacionesModal } from "./views/workers/operadores/assings/modal.component";
import { HistorialReingresosModal } from "./views/workers/operadores/historial/modal.component";
import { HasPermissionDirective } from "./components/sidebar/hasPermission.directive";
import { HasSomePermissionDirective } from "./components/sidebar/hasSomePermission.directive";
import { PasswordModal } from "./views/admin/users/pass-modal/pass-modal.component";
import { CampanaComponent } from "./views/taller/campana/campana.component";
import { CampanaForm } from "./views/taller/campana/form/form.component";
import { CampanaCalendarComponent } from "./views/taller/campana/calendar/calendar.component";
import { TiposServiciosComponent } from "./views/catalogs/tipos-servicios/tipos-servicios.component";
import { TiposServicioForm } from "./views/catalogs/tipos-servicios/form/form.component";
import { DrawerContainerComponent } from "./components/drawer/drawer.component";
import { TipoMaterialDrawerForm } from "./views/catalogs/tipos-materiales/drawer-form/drawer-form.component";
import { ImageUploadComponent } from "./components/image-upload/image-upload.component";
import { TipoServiciosDrawerForm } from "./views/catalogs/tipos-servicios/drawer-form/drawer-form.component";
import { TipoUnidadDrawerForm } from "./views/catalogs/tipos-unidades/drawer-form/drawer-form.component";
import { EmpresasDrawerForm } from "./views/catalogs/empresas/drawer-form/drawer-form.component";
import { FuncionamientoDrawerForm } from "./views/catalogs/funcionamiento/drawer-form/drawer-form.component";
import { PlantasDrawerForm } from "./views/catalogs/plantas/drawer-form/drawer-form.component";
import { ProveedorDrawerForm } from "./views/catalogs/proveedores/drawer-form/drawer-form.component";
import { UsersDrawerForm } from "./views/admin/users/drawer-form/drawer-form.component";
import { FabButtonComponent } from "./components/fab/button/fab-button.component";
import { FabContainerComponent } from "./components/fab/container/fab-container.component";
import { BlackilistDrawerForm } from "./views/workers/blacklist/drawer-form/drawer-form.component";
import { TrabajadorDrawerForm } from "./views/workers/operadores/drawer-form/drawer-form.component";
import { TrabajadorResumeComponent } from "./views/workers/operadores/resume/resume.component";

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    CardBarChartComponent,
    CardLineChartComponent,
    IndexDropdownComponent,
    PagesDropdownComponent,
    TableDropdownComponent,
    NotificationDropdownComponent,
    UserDropdownComponent,
    SidebarComponent,
    FooterComponent,
    FooterSmallComponent,
    FooterAdminComponent,
    CardPageVisitsComponent,
    CardProfileComponent,
    CardSettingsComponent,
    CardSocialTrafficComponent,
    CardStatsComponent,
    CardTableComponent,
    HeaderStatsComponent,
    MapExampleComponent,
    AuthNavbarComponent,
    AdminNavbarComponent,
    IndexNavbarComponent,
    CardFilterComponent,
    DrawerContainerComponent,
    ImageUploadComponent,
    FabContainerComponent,
    FabButtonComponent,

    AdminComponent,
    ResumenComponent,
    ResumenStatsComponent,

    AuthComponent,
    MapsComponent,
    SettingsComponent,
    TablesComponent,
    LoginComponent,
    RegisterComponent,
    IndexComponent,
    LandingComponent,
    ProfileComponent,
    DefaultComponent,
    InventarioLayout,
    EmpresasComponent,
    EmpresaForm,
    EmpresasDrawerForm,

    FuncionamientoComponent,
    FuncionamientoForm,
    FuncionamientoDrawerForm,

    OperadoresComponent,
    OperadorForm,
    BajaOperadorFormModal,
    HistorialReingresosModal,
    HistorialAsignacionesModal,
    TrabajadorDrawerForm,

    ProveedoresComponent,
    ProveedorForm,
    ProveedorDrawerForm,

    TiposMaterialesComponent,
    TipoMaterialForm,
    TipoMaterialDrawerForm,
    TrabajadorResumeComponent,

    TiposUnidadesComponent,
    TiposUnidadForm,
    TipoUnidadDrawerForm,

    UnidadesComponent,
    UnidadForm,
    RecepcionComponent,
    RecepcionForm,
    EntregaComponent,
    EntregaForm,

    MaterialsComponent,
    MaterialForm,
    InventarioComponent,
    InventarioFilteromponent,
    MovementsComponent,

    AsignacionComponent,
    AsignarModal,
    HistorialAsignarModal,

    PolizasComponent,
    PolizaForm,
    PolizaModal,

    RevisionPercancesComponent,
    RevisionPercancesForm,

    HistorialUnidadComponent,
    HistorialUnidadTableComponent,
    MantenimientoComponent,
    MantenimientoForm,

    ProgramarComponent,
    MantProgramarHistorialModal,

    HistorialMantenimientoComponent,

    PlantasComponent,
    PlantasForm,
    PlantasDrawerForm,
    MovimientosModal,

    ProgramarModal,
    MantenimientoDetalleModal,
    MantenimientoMaterialModal,
    MantenimientoIniciarModal,
    MantenimientoTerminarModal,
    MantenimientoResumenModal,

    UsersComponent,
    UsersForm,
    UsersDrawerForm,

    AlertasComponent,
    AlertasForm,
    AlertaProgramadasModal,

    ReportsComponent,

    CajaComponent,
    CajaFormComponent,
    CajaModalComponent,

    CartasCompromisoForm,
    CartasComponent,

    ActasAdminComponent,
    ActasAdminForm,

    BlackListComponent,
    BlackListForm,
    BlackilistDrawerForm,

    IdCardsComponent,

    SearchUnitsComponent,
    SearchUnitModal,
    SearchCardUnitsComponent,
    AlmacenEstantesComponent,

    PasswordModal,
    AvatarComponent,
    NotFoundComponent,
    ForbiddenComponent,

    HasPermissionDirective,
    HasSomePermissionDirective,

    CampanaComponent,
    CampanaCalendarComponent,
    CampanaForm,

    TiposServiciosComponent,
    TiposServicioForm,
    TipoServiciosDrawerForm,
    DateGmt8Pipe,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatMenuModule,
    NgxGaugeModule,
    MatChipsModule,
    ReactiveFormsModule,
    FormsModule,
    AngularSignaturePadModule,
    MatDialogModule,
    MatListModule,
    NgxSpinnerModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatCheckboxModule,
  ],
  providers: [
    AuthGuard,
    NgxImageCompressService,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
